import { render, staticRenderFns } from "./DelServiceBusiness.vue?vue&type=template&id=91703bc4&scoped=true"
import script from "./DelServiceBusiness.vue?vue&type=script&lang=js"
export * from "./DelServiceBusiness.vue?vue&type=script&lang=js"
import style0 from "./DelServiceBusiness.vue?vue&type=style&index=0&id=91703bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91703bc4",
  null
  
)

export default component.exports